import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/firstRecharge/gitfBoxhistoryFR2.png'


const _hoisted_1 = { class: "hc-history-card" }
const _hoisted_2 = { class: "hc-header" }
const _hoisted_3 = { class: "hc-date" }
const _hoisted_4 = { class: "hc-mono hc-date-text" }
const _hoisted_5 = { class: "hc-right-texts" }
const _hoisted_6 = {
  key: 0,
  class: "hc-status-badge hc-status-norewards"
}
const _hoisted_7 = {
  key: 1,
  class: "hc-status-badge hc-status-pending"
}
const _hoisted_8 = {
  key: 2,
  class: "hc-status-badge hc-status-completed"
}
const _hoisted_9 = {
  key: 3,
  class: "hc-status-badge hc-status-norewards"
}
const _hoisted_10 = {
  key: 4,
  class: "hc-status-badge hc-status-norewards"
}
const _hoisted_11 = { class: "hc-body" }
const _hoisted_12 = { class: "hc-info" }
const _hoisted_13 = { class: "hc-label-main" }
const _hoisted_14 = { class: "hc-value-main hc-mono" }
const _hoisted_15 = { class: "hc-turnover-pill" }
const _hoisted_16 = { class: "hc-mono" }
const _hoisted_17 = { class: "hc-footer" }
const _hoisted_18 = { class: "hc-stat" }
const _hoisted_19 = { class: "hc-label-sub" }
const _hoisted_20 = { class: "hc-value-sub hc-mono" }
const _hoisted_21 = { class: "hc-stat" }
const _hoisted_22 = { class: "hc-label-sub" }
const _hoisted_23 = { class: "hc-value-sub hc-mono" }

import { formatCurrency, formatUnixTimestamp } from '@/utils/commonFunction';


export default /*@__PURE__*/_defineComponent({
  __name: 'historyListFirst',
  props: {
    valueOne: {
        type: Number,
        default: 0
    },
    valueTwo: {
        type: Number,
        default: 0
    },
    time: {
        type: Number,
        default: 0
    },
    activityStatus: {
        type: Number,
        default: 0
    },
    returnTurnover: {
        type: Boolean,
        default: false
    },
    availableAmount: {
        type: Number,
        default: 0
    },
    givenAmount: {
        type: Number,
        default: 0
    }
},
  setup(__props) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "hc-accent-ribbon" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("span", { class: "hc-dot" }, null, -1)),
        _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(formatUnixTimestamp)(props.time)?.split(' ')[0]), 1)
      ]),
      _createElementVNode("span", _hoisted_5, [
        (props.activityStatus == 0 && props.returnTurnover)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.$t('activityStatus.noRewards')), 1))
          : (props.activityStatus == 0 || props.activityStatus == 11)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.$t('activityStatus.pending')), 1))
            : (props.activityStatus == 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.$t('activityStatus.completed')), 1))
              : (props.activityStatus == 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.$t('activityStatus.noRewards')), 1))
                : (props.activityStatus == 3)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.$t('activity.overdue')), 1))
                  : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "hc-gift-container" }, [
        _createElementVNode("img", {
          class: "hc-gift-icon",
          src: _imports_0,
          alt: ""
        })
      ], -1)),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('dayList.giftAmount')), 1),
        _createElementVNode("div", _hoisted_14, [
          _cache[1] || (_cache[1] = _createElementVNode("span", { class: "hc-currency" }, "R$", -1)),
          _createTextVNode(" " + _toDisplayString(props.valueOne), 1)
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createTextVNode(_toDisplayString(_ctx.$t('dayList.turnoverTimes')) + " ", 1),
          _createElementVNode("span", _hoisted_16, _toDisplayString(props.valueTwo) + "x", 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('activity.available')), 1),
        _createElementVNode("div", _hoisted_20, _toDisplayString(_unref(formatCurrency)(props.availableAmount)), 1)
      ]),
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "hc-divider" }, null, -1)),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('activity.givenAmount')), 1),
        _createElementVNode("div", _hoisted_23, _toDisplayString(_unref(formatCurrency)(props.givenAmount)), 1)
      ])
    ])
  ]))
}
}

})